/**
 * Class used to generate uri's for making api requests.
 *
 * @class Api
 */
class Api {
  /**
   *Creates an instance of Api.
   * @param {string} [baseUrl=""]
   * @memberof Api
   */
  public constructor(private readonly baseUrl: string = "") {
    const isProduction =
      process.env.NODE_ENV === "production" &&
      window.location.hostname.includes("a2z.com");
    if (!baseUrl && isProduction) {
      this.baseUrl = `https://${window.location.hostname}`;
    }
  }

  /**
   * Returns the full uri for making an api request.
   *
   * @param {string} path - The path of the request, starting with "/" eg. "/api/v1/search"
   * @returns {string}
   * @memberof Api
   */
  public getEndpointUri(path: string): string {
    return `${this.baseUrl}${path}`;
  }
}

export default Api;
